import React, {useState} from "react";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import {monthNames, shortWeekdayLabels} from "../index";
import {useAppDispatch} from "common/hook";
import {setWithDate, setWithDateNew} from "app/expense-date-reduser";
import {format} from "date-fns";

export const CalendarWith = ({ onClose }: { onClose: () => void }) => {
    const [date, setDate] = useState<Date>(new Date());
    const dispatch = useAppDispatch();

    const onDateChange = (value: any) => {
        const formattedDate = format(value, 'dd/MM/yyyy');
        const day = value.getDate();
        const monthIndex = value.getMonth();
        const year = value.getFullYear();
        const formattedDateNew = `${day} ${monthNames[monthIndex]} ${year}`;
        onClose();
        if (formattedDate) {
            dispatch(setWithDate(formattedDate));
        }
        if (formattedDate) {
            dispatch(setWithDateNew(formattedDateNew));
        }
    };

    return (
        <div className="calendar-with">
            <Calendar
                locale="ru"
                onChange={onDateChange}
                value={date}
                view="month"
                formatShortWeekday={(locale, date) =>
                    shortWeekdayLabels.weekdayShort[date.getDay()]
                }
                formatMonth={(locale, date) =>
                    new Intl.DateTimeFormat(locale, { month: "short" }).format(date)
                }
                calendarType="ISO 8601"
            />
        </div>
    );
};
